import { __awaiter } from 'tslib';
import { EventEmitter, Component, Renderer2, Input, Output, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
class NgxAuthorizenetComponent {
    constructor(renderer) {
        this.renderer = renderer;
        this.ButtonText = "Pay Now";
        this.config = {};
        this.responseHandler = new EventEmitter();
        /**
         * @param response Object from Payment
         * @description Arrow Function to retain scope for emit();
         * @return void
         */
        this.authorizeHandler = (response) => {
            this.responseHandler.emit(response);
        };
        this.getUndefined = (reference, data) => {
            if (data && data !== null) {
                return data;
            }
            throw new Error(`Data ${reference} is Undefined or Null`);
        };
    }
    /**
     * @description Load External Script(s) for authorize.net Accept Payment;
     * @return void
     */
    loadExternalScript(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = document.body;
            const script = document.createElement('script');
            script.innerHTML = '';
            script.src = url;
            script.async = true;
            script.defer = true;
            body.appendChild(script);
            this.renderer.appendChild(document.body, script);
            return script;
        });
    }
    /**
    *
    * @description Load Authorize Script before View - Extends ngOnInit;
    * @return void
    */
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.billingAddressOptions = this.getUndefined("billingAddressOptions", this.config.billingAddressOptions);
                this.urlAction = this.getUndefined("urlAction", this.config.urlAction);
                this.apiLoginID = this.getUndefined("apiLoginID", this.config.apiLoginID);
                this.clientKey = this.getUndefined("clientKey", this.config.clientKey);
                this.acceptUIFormBtnTxt = this.getUndefined("acceptUIFormBtnTxt", this.config.acceptUIFormBtnTxt);
                this.acceptUIFormHeaderTxt = this.getUndefined("acceptUIFormHeaderTxt", this.config.acceptUIFormHeaderTxt);
                yield this.loadExternalScript('https://js.authorize.net/v3/AcceptUI.js');
                window.authorizeHandler = this.authorizeHandler;
            }
            catch (error) {
                console.error(`NGXAuthorize Config Error: "${error}"`);
            }
        });
    }
}
NgxAuthorizenetComponent.ɵfac = function NgxAuthorizenetComponent_Factory(t) { return new (t || NgxAuthorizenetComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
NgxAuthorizenetComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxAuthorizenetComponent, selectors: [["ngx-authorizenet"]], inputs: { ButtonText: "ButtonText", config: "config" }, outputs: { responseHandler: "responseHandler" }, decls: 3, vars: 6, consts: [["id", "paymentForm", "method", "POST", 1, "my-4", 3, "action"], ["type", "button", "attr.data-acceptUIFormBtnTxt", "Pay", "data-responseHandler", "authorizeHandler", 1, "btn", "AcceptUI"]], template: function NgxAuthorizenetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("action", ctx.urlAction, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("data-billingAddressOptions", ctx.billingAddressOptions)("data-apiLoginID", ctx.apiLoginID)("data-clientKey", ctx.clientKey)("data-acceptUIFormHeaderTxt", ctx.acceptUIFormHeaderTxt);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.ButtonText, "\n");
    } }, styles: ["@import url(\"https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css\");button[_ngcontent-%COMP%]{box-shadow:0 2px 6px 2px rgba(204,200,200,.2);padding:10px 50px;text-align:center;margin:5px;border-radius:4px;background-image:url(../../assets/authorize-net.png);background-position:0;background-size:30px 30px;background-color:#000}button[_ngcontent-%COMP%], button[_ngcontent-%COMP%]:hover{color:#fff}img[_ngcontent-%COMP%]{width:50px;height:50px;border:5px}button[_ngcontent-%COMP%]{cursor:pointer}"] });
NgxAuthorizenetComponent.ctorParameters = () => [
    { type: Renderer2 }
];
NgxAuthorizenetComponent.propDecorators = {
    ButtonText: [{ type: Input }],
    config: [{ type: Input }],
    responseHandler: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxAuthorizenetComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-authorizenet',
                template: "<form class=\"my-4\" id=\"paymentForm\" method=\"POST\" action=\"{{urlAction}}\">\r\n    <button class=\"btn AcceptUI\" type=\"button\"\r\n    attr.data-billingAddressOptions='{{billingAddressOptions}}' attr.data-apiLoginID=\"{{apiLoginID}}\"\r\n    attr.data-clientKey=\"{{clientKey}}\" attr.data-acceptUIFormBtnTxt=\"Pay\"\r\n    attr.data-acceptUIFormHeaderTxt=\"{{acceptUIFormHeaderTxt}}\" data-responseHandler=\"authorizeHandler\">\r\n    {{ButtonText}}\r\n</button>\r\n</form>",
                styles: ["@import url(\"https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css\");button{box-shadow:0 2px 6px 2px rgba(204,200,200,.2);padding:10px 50px;text-align:center;margin:5px;border-radius:4px;background-image:url(../../assets/authorize-net.png);background-position:0;background-size:30px 30px;background-color:#000}button,button:hover{color:#fff}img{width:50px;height:50px;border:5px}button{cursor:pointer}"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }]; }, { ButtonText: [{
            type: Input
        }], config: [{
            type: Input
        }], responseHandler: [{
            type: Output
        }] }); })();

class NgxAuthorizenetModule {
}
NgxAuthorizenetModule.ɵfac = function NgxAuthorizenetModule_Factory(t) { return new (t || NgxAuthorizenetModule)(); };
NgxAuthorizenetModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxAuthorizenetModule });
NgxAuthorizenetModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxAuthorizenetModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NgxAuthorizenetComponent
                ],
                imports: [],
                exports: [
                    NgxAuthorizenetComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxAuthorizenetModule, { declarations: [NgxAuthorizenetComponent], exports: [NgxAuthorizenetComponent] }); })();

/*
 * Public API Surface of ngx-authorizenet
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxAuthorizenetComponent, NgxAuthorizenetModule };

